import { Mapper } from './mapper';

export const TipoRegimeJornada = Mapper.from([
  [1, 'Submetido a horário de trabalho (Capítulo II do Título II da CLT)'],
  [2, 'Atividade externa especificada no inciso I do art. 62 da CLT'],
  [3, 'Função especificada no inciso II do art. 62 da CLT'],
  [4, 'Teletrabalho, previsto no inciso III do art. 62 da CLT'],
]);
